export default {
  '员工管理': '员工管理',
  '生产小组':'生产小组',
  '数据统计':'数据统计',
  '订单详情':'订单详情',
  '订单重做统计':'订单重做统计',
  '订单修改':'订单修改',
  '添加订单':'添加订单',
  '电子开版':'电子开版',
  '模板库':'模板库',
  '模板详情':'模板详情',
  '开版详情':'开版详情',



  tongyongObj: {
    piliang:'批量',
    piliangfahuo:'批量发货',
    daochuExcel:'导出Excel',
    xiazai:'下载',
    fankuitupian:'反馈图片',
    xiazaichenggong:'下载成功',
    caozuoshibai:'操作失败',
    qingqiushibai:'请求失败',
    xiaoshou: '销售',
    guanliyuan: '管理员',
    shenfen: '身份',
    xiugaixinxi: '修改信息',
    tuichu: '退出登录',
    shouye: '首页',
    shujutongji: '数据统计',
    yuangongguanli: '员工管理',
    shengchanxiaozu: '生产小组',
    tianjiadingdan: '添加订单',
    daorudingdanliebiao: '导入订单列表',
    xiazaidingdanmuban: '下载订单模板',
    tishi: '提示',
    niquedingyaotuichudengluma: '您确定要退出登录吗？',
    queding: '确定',
    quxiao: '取消',
    tuichuchenggong: '退出成功!',
    cicaozuojiangjinyong: '此操作将禁用该信息, 是否继续?',
    cicaozuojiangqiyong: '此操作将启用该信息, 是否继续?',
    cicaozuojiangshanchu:'此操作将永久删除该信息, 是否继续?',
    shanchuchenggong: '删除成功!',
    yiquxiaoshanchu: '已取消删除',
    ninquedingyaochexiaogongxuma: '您确定要撤销工序吗?',
    chexiaochenggong: '撤销成功!',
    yiquxiaochexiao: '已取消撤销',
    caozuochenggong: '操作成功!',
    qingxuanzexiayibugongxu: '请选择下一步工序',
    mubanku: '模板库',

    dingdantezhengxinxi: '订单特征信息',
    kaibanjichuxinxi: '开版基础信息',
    chongwupinlei: '宠物品类',
    chongwutezheng: '宠物特征',
    wenjianxinxi: '文件信息',
    xiazaikaibanwenjian: '下载开版文件',
    maoliaoxinxi:'毛料信息',
    mingcheng: '名称',
    quyu: '区域',
    beizhuxinxi: '备注信息',
    beizhu:'备注',
    zhengzainvlidaochu:'正在努力导出中...',
    qingshuruchongwupinlai: '请输入宠物品类',
    qingshuruneirong: '请输入内容',
    kedianjixiazai: '可点击下载',




    maoliaomingcheng: '毛料名称',
    qingshurumaoliaomingcheng: '请输入毛料名称',
    maoliaoquyu:'毛料区域',
    qingshurumaoliaoquyu:'请输入毛料区域',
    wancheng:'完成',
    wanchengbingbaocunmuban:'完成并保存模板',
    yanjing:'眼睛',
    bizi:'鼻子',
    jiaozhang:'脚掌',
    qingshurupinlei:'请输入品类',
    qingshuruchongwutezheng:'请输入宠物特征',
    qingshurukaibanjichuxinxi:'请输入开版基础信息',
    qingshangchuankaibanwenjian:'请上传开版文件',
    pinlei:'品类',
    maoliao:'毛料',
    tezheng:'特征',
    sousuoneirong:'搜索内容',
    qingshurudingdanbianhao:'请输入订单编号',
    mubanbianhao:'模板编号',
    dingdanhao:'订单号',
    riqi:'日期',
    yuanshidingdantupian:'原始订单图片',
    xuanzegaimuban:'选择该模板',
    shanchumuban:'删除模板',
    qingshurudingdanhao:'请输入订单号',
    kaibanwenjianshifouxiazai:'开版文件是否下载',
    piliangdaochukaibanwenjian:'批量导出开版文件',
    piliangdaochutiaoxingma:'批量导出条形码',
    piliangdaochugongyikapian:'批量导出工艺卡片',
    dengdaikaiban:'等待开版',
    daixiazai:'待下载',
    yixiazai:'已下载',
    chakantiaoxingma:'查看条形码',
    shengchenggongyikapian:'生成工艺卡片',
    tiaoxingma:'条形码',
    weixiazai:'未下载',
    yixiazai:'已下载',
    qingxuanzedingdan:'请选择订单',

    bianjiyuangongxinxi:'编辑员工信息',
    xinzengyuangong:'新增员工',
    yuangongshenfen:'员工身份',
    dengluzhanghao:'登录账号',
    denglumima:'登录密码',
    shuruip:'请输入IP,空表示不限制，多个IP使用英文,分隔',
    gengxinxinxi:'更新信息',
    bianjishengchanxiaozu:'编辑生产小组',
    xinzengshengchanxiaozu:'新增生产小组',
    xiaozumingcheng:'小组名称',
    dianzikaibanyuangong:'电子开版员工',
    shijianjiange:'时间间隔',
    jiguangcaiqieyuangong:'激光裁切员工',
    chefengyuangong:'车缝员工',
    chongmianyuangong:'充棉员工',
    zaoxingyuangong:'造型员工',
    penyouyuangong:'喷油员工',
    zhijianyuangong:'质检员工',
    qingshurumingcheng:'请输入名称',
    qingxuanzeyuangong:'请选择员工',
    qingshurushijianjiange:'请输入时间间隔(天)',
    qingshuruxiaozumingcheng:'请输入小组名称',
    xinzengxiaozu:'新增小组',
    chuangjianshijian:'创建时间',
    xiaozuchengyuan:'小组成员',
    dingdanfangongtongji:'订单重做统计',
    dingdanwanchengshijian:'订单完成时间',
    yuangongxingming:'员工姓名',
    shifoufangong:'是否重做',
    daochudingdan:'导出订单',
    yichulidingdanshuliang:'已处理订单数量',
    weifangongdingdanshuliang:'未重做订单数量',
    fangongdingdanshuliang:'重做订单数量',
    shi:'是',
    fou:'否',
    yicifangongshuliang:'一次重做订单数量',
    ercifangongshuliang:'二次重做订单数量',
    sancifangongshuliang:'三次重做订单数量',
    fankuineirong:'反馈内容',
    dianjishangchuanfankuitu:'点击上传反馈图',
    tijiaofankui:'提交反馈',
    qingshuruneironghuoshangchuantupian:'请输入内容或上传图片',
    zhidingshengchanxiaozu:'指定生产小组',
    xuanzexiaozu:'选择小组',
    xuanzedianzikaibanshijian:'选择电子开版时间',
    xiadanshijian:'下单时间',
    wanchengshijian:'完成时间',
    gongchangjiaoqi:'工厂交期',
    piliangfenpei:'批量分配',
    piliangzhidingxiaozu:'批量指定小组',
    fenpei: '分配',
    zhidingxiaozu: '指定小组',
    tiaozhengfenpei: '调整分配',
    dingdanfenpei: '订单分配',
    gongxuyidianzikaiban: '工序1-电子开版',
    gongxuerjiguangcaiqie: '工序2-激光裁切',
    gongxusanchefeng: '工序3-车缝',
    gongxusichongmian: '工序4-充棉',
    gongxuwuzaoxing: '工序5-造型',
    gongxuliupenyou: '工序6-喷油',
    gongxuqizhijian: '工序7-质检',
    qingxuanzeyuangongyijiwanchengshijian: '请选择员工以及完成时间',
    xuanzeyuangongjishijian: '选择员工及时间',
    shengchanfuzeren: '生产负责人',
    quedingxuanze: '确定选择',
    tijiaoshuju: '提交数据',
    qingxuanzedianzikaibanyuangong: '请选择电子开版员工',
    qingxuanzejiguangcaiqieyuangong: '请选择激光裁切员工',
    qingxuanzezhijianyuan: '请选择质检员',
    fenpeichenggong: '分配成功',
    denglu: '登录',
    qingshurudengluzhanghao: '请输入登录账号',
    qingshurudenglumima: '请输入登录密码',
    qingshuruyanzhengma: '请输入验证码',
    dengluchenggong: '登录成功!',
    dingdanshuliang: '订单数量',
    zhizuozhouqi: '制作周期',
    gukexinxi: '客户信息',
    chicun:'尺寸',
    zishi:'姿势',
    zuibaxingzhuang:'嘴巴形状',
    yanjingyanse:'眼睛颜色',
    laliandai:'拉链袋',
    lianbutupian:'脸部图片',
    tupianyi:'图片1',
    tupianer:'图片2',
    tupiansan:'图片3',
    tupiansi:'图片4',
    tupianwu:'图片5',
    tupianliu:'图片6',
    tupianqi:'图片7',
    tupianba:'图片8',
    tupianjiu:'图片9',
    tupianshi:'图片10',
    tipianshiyi:'图片11',
    tupianshier:'图片12',
    maopi:'毛坯',
    jiaozhangdeyanse:'脚掌的颜色',
    tongkongdexingzhuang:'瞳孔的形状',
    huxu:'胡须',
    maochang:'毛长',
    maofaxingzhuang:'毛发形状',
    touxing:'头型',
    erduoxingzhuang:'耳朵形状',
    weibaxingzhuang:'尾巴形状',
    biziyinying:'鼻子阴影',
    yanxian:'眼线',
    fujian:'附件',
    fujianer:'附件2',
    caozuozhe:'操作者',
    caozuoshijian:'操作时间',
    tuji:'图集',
    caozuofuzeren:'操作负责人',
    yujiwanchengshijian:'预计完成时间',
    dingdanrizhi:'订单日志',
    caozuoneirong:'操作内容',
    gukexinxi:'顾客信息',
    zhiliangjiancezhong:'质量检测中',
    duogepingtaishiyongdouhaofenxiang:'多个平台之间使用英文,分隔',




    jichuxinxi:'基础信息',
    pingtaibianhao:'平台编号',
    pinzhong:'品种',
    xiadanriqi:'下单日期',
    zhizuozhouqi:'制作周期',
    shifouxuyao:'是否需要',
    pensetu:'喷色图',
    maochangtu:'毛长图',
    qingdingzhi:'轻定制',
    maodemaopi:'猫的毛坯',
    jiaozhangya:'脚掌颜色',
    tongkongxingzhuang:'瞳孔形状',
    fenxiao:'分销',
    qita:'其他',
    lijichuangjian:'立即创建',
    quanbu:'全部',
    jinsheng:'仅剩',
    tian:'天',
    biaojiweiyidu: '标记为已读',
    fenpeikehu:'分配客户',
    
    qingshurufankuineirong:'请输入反馈内容',



    zhanzi:'站姿',
    zuozi:'坐姿',
    pazai:'趴姿',
    cezhan:'侧躺',

    zhangzui:'张嘴',
    biezui:'闭嘴',
    zhangzuituoshe:'张嘴吐舌',
    biezuituoshe:'闭嘴吐舌',

    chuizhi:'垂直',
    yuanxing:'圆形',

    xuyao:'需要',
    buxuyao:'不需要',
    zhizuowancheng:'制作完成',
    yichaoqi:'已超期',
    shifouchaoqi:'是否超期',
    xaizaituji:'下载图集',
    duanmao:'短毛',
    changmao:'长毛',
    fense:'粉色',
    heise:'黑色',
    huise:'灰色',
    yichao:'已超',

  },
  tongjiObj: {
    daichulidingdan: '等待生产订单',
    yichulidingdan: '已处理订单',
    shengchanzhongdingdan: '生产中订单',
    yiwanchengdingdan: '已完成订单',
    yifahuodingdan: '发货完成订单',
    fangongdingdan: '重做订单',
    yiquxiaodingdan: '已取消订单',
  },
  shaixuanObj: {
    dingdanbianhao: '订单编号',
    xiadanpingtai: '下单平台',
    gongchanbianhao: '工厂编号',
    dingdanleixing: '订单类型',
    dingdanzhuangtai: '订单状态',
    chongwupinzhong: '宠物品种',
    shengchanjindu: '生产进度',
    shengchanzhiliushijian: '生产滞留时间',
    dingdanriqi: '订单日期',
    jiaohuoriqi: '交货日期',
    xiaoshouyuan: '销售员',
    sousuo: '搜索',
    chongzhi: '重置',
    qingshuru: '请输入',
    qingxuanze: '请选择',
    gongxujiezhishijian: '工序截止时间',
    shijiwanchengshijian: '实际完成时间',
    fangongwanchengshijian: '重做完成时间',
    zhi: '至',
    kaishiriqi: '开始日期',
    jieshuriqi: '结束日期',
  },
  ordersObj: {
    dingdanbianhao: '订单编号(平台编号)',
    xiadanpingtai: '下单平台',
    gongchanbianhao: '工厂编号',
    dingdanleixing: '订单类型',
    dingdanriqi: '订单日期',
    jiaohuoriqi: '交货日期',
    dingdanzhuangtai: '订单状态',
    chongwupinzhong: '宠物品种',
    shengchanjindu: '生产进度',
    shengchanzhiliushijian: '生产滞留时间',
    caozuo: '操作',
    quxiaodingdan: '取消订单',
    dingdanfahuo: '订单发货',
    fankuixinxi: '反馈信息',
    xiugaidingdan: '修改订单',
    dingdanxiangqing: '订单详情',
    jiazaizhong: '加载中',
    daichuli: '等待生产',
    yichuli: '已处理',
    fangong: '重做',
    chongmianwanchengshijian: '充棉完成时间',
    shijiwanchengshijian: '实际完成时间',
    fangongwanchengshijian: '重做完成时间',
    shangbugongxuweichuli: '上步工序未处理',
    wanchenggongxu: '完成工序',
    wanchengfangong: '完成重做',
    chexiao: '撤销',
    kaibanxiangqing: '开版详情',
    xuanzexiayibugongxu: '选择下一步工序',
    gongxu: '工序',
    zhijianwanchengshijian: '质检完成时间',
    shijiwanchengshijian: '实际完成时间',
    zaoxingwanchengshijian: '造型完成时间',

    jianyantongguo: '检验通过',
    jianyanbutongguo: '不通过(返工)',
    zhijianyijian: '质检意见',
    shangchuanchengpintu: '上传成品图',
    dianjishangchuan: '点击上传',
    zhinengshangchuan:'只能上传jpg/png文件，且不超过10MB',
    
    penyouwanchengshijian: '喷油完成时间',
    kaibanwanchengshijian: '开版完成时间',
    shoudongkaiban: '手动开版',
    mubankaiban: '模板开版',
    xiugaikaiban: '修改开版',
    caiqiewanchengshijian: '裁切完成时间',
    chefengwanchengshijian: '车缝完成时间',
    yundanhao: '运单号',
  },
  // 订单状态
  dingdanzhuangtaiObj: {
    fangong: '重做',
    daichuli: '等待生产',
    shengchanzhong: '生产中',
    yiwancheng: '完成等待发货',
    yifahuo: '发货完成',
    yiquxiao: '已取消',
    zhiliangjiancezhong: '质量检测中',
  },
  // 生产状态
  shengchanzhuangtaiObj: {
    dianzikaiban: '电子开版',
    jiguangcaiqie: '激光裁切',
    chefeng: '车缝',
    chongmian: '充棉',
    zaoxing: '造型',
    penyou: '喷油',
    zhijian: '质检',
  },
  gaimimaObj: {
    genggaimima: '更新密码',
    xinmima: '新密码',
    querenmima: '确认密码',
    quxiao: '取消',
    lijixiugai: '立即修改',
    xiugaichenggongqingchongxindenglu: '修改成功，请重新登录!',
    liangcimimabuyizhi: '两次密码不一致!',

    chongzhimima: '重置密码',
    mima: '密码',
    tijiaoxinxi: '提交信息',

  },
  yuangongObj:{
    xingming: '姓名',
    zhanghao: '账号',
    yuangongshenfen: '员工身份',
    zhuangtai: '状态',
    chuangjianriqi: '创建日期',
    caozuo: '操作',
    bianji: '编辑',
    chongzhimima: '重置密码',
    jinyong: '禁用',
    qiyong: '启用',
    shanchu: '删除',
    xinzenggongren: '新增员工',
    jiazaizhong: '加载中',
    
    dianhua: '电话',
    guojia: '国家',
    shengfen: '省',
    chengshi: '城市',
    youbian: '邮编',
    dizhi: '地址',
 
   
  },
  zhiweiObj:{
    jingli: '经理',
    xiaoshou: '销售',
    dianzikaiban: '电子开版',
    jiguangcaiqie: '激光裁切',
    chefeng: '车缝',
    chongmian: '充棉',
    zaoxing: '造型',
    penyou: '喷油',
    zhijian: '质检',
    kehu: '客户',
  }
  // 其他中文翻译...
}


// WEBPACK FOOTER //
// ./src/locales/lang/zh-CN.js